
































import { ErrorCodes } from '@ringana/errors';
import EErrorCodes from '@ringana/errors/lib/enums/error-codes';
import Vue from 'vue';
import { ICalendarDoorBase, ICalendarContentDoor, ICalendarProductDoor } from '@/common/interfaces/announcement-bar.interface';
import CalendarCloseButton from '@/components/announcementbar/christmas-calendar/subcomponents/CalendarCloseButton.vue';
import ChristmasCalendarDesktopView from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarDesktopView.vue';
import ChristmasCalendarMobileView from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarMobileView.vue';
import InformationOverlay from '@/components/announcementbar/christmas-calendar/subcomponents/InformationOverlay.vue';
import AnnouncementBarHelper from '@/helpers/AnnouncementBarHelper';
import PartnerShopHelper from '@/helpers/page-specific/PartnerShopHelper';
import SessionStorageHelper from '@/helpers/SessionStorageHelper';
import TIcons from '@/types/TIcons';

interface IChristmasCalendarComponent {
  calculateContainerHeightFunction: null | (() => void);
  containerHeightInlineStyle: string;
  doorContent: ICalendarContentDoor | ICalendarProductDoor | null;
  isPartnerShop: boolean;
  overlay: {
    type: `early` | `late` | null;
    visible: boolean;
  };
}

export default Vue.extend({
  name: `ChristmasCalendar`,
  components: {
    CalendarCloseButton,
    ChristmasCalendarDesktopView,
    ChristmasCalendarMobileView,
    InformationOverlay,
  },
  data(): IChristmasCalendarComponent {
    return {
      calculateContainerHeightFunction: null,
      containerHeightInlineStyle: `height: auto;`,
      doorContent: null,
      isPartnerShop: false,
      overlay: {
        type: null,
        visible: false,
      },
    };
  },
  computed: {
    currentDay(): number {
      return new Date().getDate();
    },
    currentDayIdForMobile(): number {
      return this.doors[this.currentDay - 1].id;
    },
    logoPath(): string {
      return PartnerShopHelper.isPageInPartnerShop() ? TIcons.ringanaLogoPartner : TIcons.ringanaLogo;
    },
  },
  props: {
    barHeight: {
      default: 0,
      type: Number,
    },
    doors: {
      required: true,
      type: Array as () => ICalendarDoorBase[],
    },
    title: {
      required: true,
      type: String,
    },
    visible: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    window.addEventListener(`keyup`, this.onKeyUp);
    SessionStorageHelper.setChristmasCalendarSeen();
    this.calculateContainerHeightFunction = window._.debounce(this.calculateContainerHeight, 125);
    window.addEventListener(`resize`, this.calculateContainerHeightFunction);
  },
  beforeDestroy(): void {
    if(typeof this.calculateContainerHeightFunction === `function`) {
      window.removeEventListener(`resize`, this.calculateContainerHeightFunction);
    }
    window.removeEventListener(`keyup`, this.onKeyUp);
  },
  methods: {
    calculateContainerHeight(): void {
      if(window.innerWidth > 768) {
        this.containerHeightInlineStyle = `height: auto`;
      } else if(this.barHeight === 0) {
        // 50px = @mobileAnnouncementBarHeight - change here and in rin-ab-calendar.less
        // 25px = @mobileCalendarGapToScreenEdge - change here and in rin-ab-calendar.less
        this.containerHeightInlineStyle = `height: calc(100vh - 50px - (25px * 2));`;
      } else {
        // 25px = @mobileCalendarGapToScreenEdge - change here and in rin-ab-calendar.less
        this.containerHeightInlineStyle = `height: calc(100vh - ${this.barHeight}px - (25px * 2))`;
      }
    },
    closeCalendar(): void {
      this.closeOverlay();
      this.$emit(`close:calendar`);
    },
    closeOverlay(): void {
      this.overlay = {
        type: null,
        visible: false,
      };
    },
    onKeyUp(event: KeyboardEvent): void {
      if(event.code === `Escape`) {
        this.closeCalendar();
      }
    },
    async openSelectedBauble(doorId: number): Promise<void> {
      try {
        this.doorContent = AnnouncementBarHelper.transformContentDoorToContentDoorWithOverline((await this.$abApiService.getDoorById(doorId)), this.title);
      } catch (err) {
        const errorCode: ErrorCodes = err?.info?.errorCode;
        if(errorCode) {
          switch(errorCode) {
            case EErrorCodes.ANNOUNCEMENT_CALENDAR_DOOR_TOO_EARLY:
              this.overlay = {
                type: `early`,
                visible: true,
              };
              break;
            case EErrorCodes.ANNOUNCEMENT_CALENDAR_DOOR_TOO_LATE:
              this.overlay = {
                type: `late`,
                visible: true,
              };
              break;
            default:
              throw err;
          }
        } else {
          throw err;
        }
      }
    },
  },
  watch: {
    barHeight: {
      immediate: true,
      handler(): void {
        this.calculateContainerHeight();
      },
    },
  },
});
